import { answer } from './post';

export const survey = {
  answer,
};
